import React from 'react'
import { Dialog, Box } from '@chakra-ui/react'

export const ExternalContentModal = ({ isOpen, onClose, url, title }) => (
  <Dialog.Root open={isOpen} onOpenChange={(details) => !details.open && onClose()} size="full">
    <Dialog.Backdrop />
    <Dialog.Positioner>
      <Dialog.Content maxW="480px" h="90vh" m="auto">
        <Dialog.CloseTrigger top="12px" right="12px" zIndex={2} bg="white" borderRadius="full" _hover={{ bg: 'gray.100' }} />
        <Dialog.Body p={0}>
          <Box w="100%" h="100%">
            <iframe
              src={url}
              title={title}
              sandbox="allow-same-origin"
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
              }}
            />
          </Box>
        </Dialog.Body>
      </Dialog.Content>
    </Dialog.Positioner>
  </Dialog.Root>
)
